import { render, staticRenderFns } from "./LoadFilesNew.vue?vue&type=template&id=664461a0&"
import script from "./LoadFilesNew.vue?vue&type=script&lang=js&"
export * from "./LoadFilesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664461a0')) {
      api.createRecord('664461a0', component.options)
    } else {
      api.reload('664461a0', component.options)
    }
    module.hot.accept("./LoadFilesNew.vue?vue&type=template&id=664461a0&", function () {
      api.rerender('664461a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/LoadFilesNew.vue"
export default component.exports